import React, {useContext, useState} from 'react';
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import escapeRegExp from "lodash/escapeRegExp"
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {CONFIG_TYPE} from "../../../util/Constants";
import Icon from "@amzn/meridian/icon";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";

const DeleteAdtfSorterConfigurationModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac} = props;
    const {getDraftData, deleteInstance, deleteAll} = useContext(DraftContext);
    const {open, setOpen} = props;
    const [destinationId, setDestinationId] = useState("")
    const [sorterId, setSorterId] = useState("")
    const [destinationIdSearchQuery, setDestinationIdSearchQuery] = useState("")
    const [sorterIdSearchQuery, setSorterIdSearchQuery] = useState("")

    const onCloseModal = () => {
        setOpen(false);
        resetInputState();
    }

    const stateValues = {
        destinationId: destinationId,
        sorterId: sorterId,
        mac: mac
    }

    const sorterConfig = getDraftData({stateKey: CONFIG_TYPE.ADTF_SORTER_DESTINATION, subKey: mac});
    let destinationIdList = sorterConfig.map(({destinationId}) => destinationId);
    let sorterIdList = sorterConfig.map(({sorterId}) => sorterId);
    const destinationIdSearchRegExp = new RegExp(escapeRegExp(destinationIdSearchQuery), "i")
    const sorterIdSearchRegExp = new RegExp(escapeRegExp(sorterIdSearchQuery), "i")

    // Converting to set to remove non-unique destination ids from DDB form
    destinationIdList = [...new Set(destinationIdList.filter(
        option => !destinationIdSearchQuery || destinationIdSearchRegExp.test(option)
    ))]

    sorterIdList = [...new Set(sorterIdList.filter(
        option => !sorterIdSearchQuery || sorterIdSearchRegExp.test(option)
    ))]


    const onClickConfirm = (stateValues) => {
        deleteData(stateValues);
        setOpen(false)
        resetInputState();
    }

    function resetInputState() {
        setDestinationId("");
    }

    const deleteData = (stateValues) => {
        deleteInstance({
            stateKey: CONFIG_TYPE.ADTF_SORTER_DESTINATION,
            subKey: stateValues.mac,
            keyComparator: (instance) => (
                instance.destinationId === stateValues.destinationId &&
                instance.sorterId === stateValues.sorterId
            )
        })
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "device.delete_config_button_modal"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column>
                    <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                        Please select the Destination Id and Sorter Id you would like to remove:
                    </Text>
                    <Select
                        value={destinationId}
                        onChange={setDestinationId}
                        searchQuery={destinationIdSearchQuery}
                        onSearch={setDestinationIdSearchQuery}
                        placeholder={"Select destination ID"}
                        width="100%">
                        {destinationIdList.map((destinationId) => (
                            <SelectOption key={destinationId} value={destinationId} label={destinationId}/>
                        ))}
                        {!destinationIdList.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                {destinationIdList ? <Text alignment="center"> No matching destination IDs </Text>
                                    : <Text alignment="center"> No destination IDs available </Text>}
                            </Column>) : null}
                    </Select>
                    <Select
                        value={sorterId}
                        onChange={setSorterId}
                        searchQuery={sorterIdSearchQuery}
                        onSearch={setSorterIdSearchQuery}
                        placeholder={"Select sorter ID"}
                        width="100%">
                        {sorterIdList.map((sorterId) => (
                            <SelectOption key={sorterId} value={sorterId} label={sorterId}/>
                        ))}
                        {!sorterIdList.length ? (
                            <Column alignmentVertical="center" spacing="100" spacingInset="100">
                                {destinationIdList ? <Text alignment="center"> No matching sorter IDs </Text>
                                    : <Text alignment="center"> No sorter IDs available </Text>}
                            </Column>) : null}
                    </Select>
                </Column>
                <ModalFooter>
                    <Row alignmentHorizontal="justify" widths="fit">
                        <Button
                            size="small"
                            className="redBtn"
                            onClick={() => {
                                deleteAll({stateKey: CONFIG_TYPE.ADTF_SORTER_DESTINATION, subKey: stateValues.mac});
                                onCloseModal();
                            }}
                        >
                            <Icon tokens={trashTokens} />
                            <FormattedMessage id="modal.deleteAll" defaultMessage="Delete All"/>
                        </Button>
                        <Row alignmentHorizontal="right" widths="fit">
                            <Button type="secondary" size="small" onClick={onCloseModal}>
                                <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                            </Button>
                            <Button type="primary" size="small" onClick={() => onClickConfirm(stateValues)}>
                                <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                            </Button>
                        </Row>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(DeleteAdtfSorterConfigurationModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/modal/DeleteAdtfSorterConfigurationModal.js